import React from 'react';

import { css } from '@emotion/core';
import styled from '@emotion/styled';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { mq } from '@helpers/breakpoints';
import Colors from '@theme/colors';

const FormButton = ({ disabled, ...props }: any) => {
  return (
    <button {...props} data-i={props.dataI} disabled={disabled || props.loading}>
      {props.children}
      {props.loading && (
        <FontAwesomeIcon
          icon={['fas', 'spinner-third']}
          className="fa-spin"
          css={mq({
            color: Colors.neutral0,
            margin: '0 0 0 10px',
          })}
        />
      )}
    </button>
  );
};

const FormButtonStyle = (props) => css`
  background: ${props.isBackButton ? Colors.darkBlueGray : '#58c323'};
  border: ${props.isBackButton ? '1px solid #ccc' : 0};
  border-radius: 6px;
  color: ${props.isBackButton ? Colors.neutral0 : Colors.neutral0};
  font-size: 1.2em;
  font-weight: bold;
  height: 56px;
  padding: 0 15px;

  &:hover {
    cursor: pointer;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.7;
  }
`;

const FormButtonStyled = styled(FormButton)`
  ${FormButtonStyle}
`;

export { FormButtonStyled as FormButton };
